/* UnionX — Selector Boleta/Factura (captura de datos tributarios en el carrito Shopify).
 *
 * QUE HACE: guarda la eleccion del cliente (boleta/factura) + RUT/razon social/giro/comuna/
 * direccion como cart attributes (billing_*). SOLO CAPTURA — el DTE lo emite Odoo.
 * El workflow n8n "[UXP] B2C - Factura Capture - Odoo" lee esos attributes y los escribe
 * en x_factura_* del sale.order; el cron 146 de Odoo emite la factura 33.
 *
 * POR QUE EN UN ASSET Y NO INLINE EN EL SNIPPET:
 * en temas con carrito AJAX (Simplit) el HTML del carrito se inyecta con innerHTML y los
 * <script> inline NO se ejecutan. Este archivo se carga una vez desde el layout y se
 * re-inicializa solo cuando el carrito se vuelve a renderizar (MutationObserver).
 *
 * Se apoya en delegacion a nivel document, asi funciona igual en:
 *   - UnionX  : boton dentro del form del carrito
 *   - Lhotse  : boton FUERA del form, asociado por form="cart"
 *   - Simplit : carrito re-renderizado por AJAX
 */
(function () {
  'use strict';
  if (window.__uxFacturaSelector) return;
  window.__uxFacturaSelector = true;

  var REQUERIDOS = ['rut', 'rzn_social', 'giro', 'comuna', 'direccion'];

  /* ---------- comunas de Chile (fuente: res.city de Odoo, 346) para autocompletar ----------
   * El datalist ayuda al cliente a elegir una comuna VALIDA -> el corrector (cron 146) la
   * resuelve siempre (x_factura_comuna -> res.city) y el SII no rechaza por comuna vacia/basura.
   * Sigue siendo texto libre (fallback), pero el autocompletar empuja a la lista buena.        */
  var COMUNAS = ["Aisén","Algarrobo","Alhué","Alto Biobío","Alto Hospicio","Alto del Carmen","Ancud","Andacollo","Angol","ANTÁRTICA","Antofagasta","Antuco","Arauco","Arica","Buin","Bulnes","Cabildo","Cabo de Hornos","Cabrero","Calama","Calbuco","Caldera","Calera","Calera de Tango","Calle Larga","Camarones","Camiña","Canela","Cañete","Carahue","Cartagena","Casablanca","Castro","Catemu","Cauquenes","Cerrillos","Cerro Navia","Chaitén","Chanco","Chañaral","Chépica","Chiguayante","Chile Chico","Chillán","Chillán Viejo","Chimbarongo","Cholchol","Chonchi","Cisnes","Cobquecura","Cochamó","Cochrane","Codegua","Coelemu","Coihaique","Coihueco","Coinco","Colbún","Colchane","Colina","Collipulli","Coltauco","Combarbalá","Concepción","Conchalí","Concón","Constitución","Contulmo","Copiapó","Coquimbo","Coronel","Corral","Cunco","Curacautín","Curacaví","Curaco de Vélez","Curanilahue","Curarrehue","Curepto","Curicó","Dalcahue","Diego de Almagro","Doñihue","El Bosque","El Carmen","El Monte","El Quisco","El Tabo","Empedrado","Ercilla","Estación Central","Florida","Freire","Freirina","Fresia","Frutillar","Futaleufú","Futrono","Galvarino","General Lagos","Gorbea","Graneros","Guaitecas","Hijuelas","Hualaihue","Hualañé","Hualpén","Hualqui","Huara","Huasco","Huechuraba","Illapel","Independencia","Iquique","Isla de Maipo","Isla de Pascua","Juan Fernández","La Cisterna","La Cruz","La Estrella","La Florida","La Granja","La Higuera","La Ligua","La Pintana","La Reina","La Serena","La Unión","Lago Ranco","Lago Verde","Laguna Blanca","Laja","Lampa","Lanco","Las Cabras","Las Condes","Lautaro","Lebu","Licantén","Limache","Linares","Litueche","Llanquihue","Llay Llay","Lo Barnechea","Lo Espejo","Lo Prado","Lolol","Loncoche","Longaví","Lonquimay","Los Alamos","Los Andes","Los Angeles","Los Lagos","Los Muermos","Los Sauces","Los Vilos","Lota","Lumaco","Máfil","Machalí","Macul","Maipú","Malloa","Marchihue","María Elena","María Pinto","Mariquina","Maule","Maullín","Mejillones","Melipeuco","Melipilla","Molina","Monte Patria","Mostazal","Mulchén","Nacimiento","Nancagua","Natales","Navidad","Negrete","Ninhue","Nogales","Nueva Imperial","Ñiquén","Ñuñoa","Ohiggins","Olivar","Ollague","Olmué","Osorno","Ovalle","Padre Hurtado","Padre Las Casas","Paihuano","Paillaco","Paine","Palena","Palmilla","Panguipulli","Panquehue","Papudo","Paredones","Parral","Pedro Aguirre Cerda","Pelarco","Pelluhue","Pemuco","Pencahue","Penco","Peñaflor","Peñalolén","Peralillo","Perquenco","Petorca","Peumo","Pica","Pichidegua","Pichilemu","Pinto","Pirque","Pitrufquén","Placilla","Portezuelo","Porvenir","Pozo Almonte","Primavera","Providencia","Puchuncaví","Pucón","Pudahuel","Puente Alto","Puerto Montt","Puerto Octay","Puerto Varas","Pumanque","Punitaqui","Punta Arenas","Puqueldón","Purén","Purranque","Putaendo","Putre","Puyehue","Queilén","Quellón","Quemchi","Quilaco","Quilicura","Quilleco","Quillón","Quillota","Quilpué","Quinchao","Quinta Normal","Quinta de Tilcoco","Quintero","Quirihue","Rancagua","Ranquil","Rauco","Recoleta","Renaico","Renca","Rengo","Requinoa","Retiro","Rinconada","Río Bueno","Río Claro","Río Hurtado","Río Ibáñez","Río Negro","Río Verde","Romeral","Saavedra","Sagrada Familia","Salamanca","San Antonio","San Bernardo","San Carlos","San Clemente","San Esteban","San Fabián","San Felipe","San Fernando","San Gregorio","San Ignacio","San Javier","San Joaquín","San José de Maipo","San Juan de la Costa","San Miguel","San Nicolás","San Pablo","San Pedro","San Pedro De La Paz","San Pedro de Atacama","San Rafael","San Ramón","San Rosendo","San Vicente","Santa Bárbara","Santa Cruz","Santa Juana","Santa María","Santiago","Santo Domingo","Sierra Gorda","Talagante","Talca","Talcahuano","Taltal","Temuco","Teno","Teodoro Schmidt","Tierra Amarilla","Til til","Timaukel","Tirua","Tocopilla","Toltén","Tomé","Torres del Paine","Tortel","Traiguén","Trehuaco","Tucapel","Valdivia","Vallenar","Valparaíso","Vichuquén","Victoria","Vicuña","Vilcún","Villa Alegre","Villa Alemana","Villarrica","Viña del Mar","Vitacura","Yerbas Buenas","Yumbel","Yungay","Zapallar"];
  function ensureDatalist() {
    if (!document.body || document.getElementById('ux-comunas')) return;
    var dl = document.createElement('datalist');
    dl.id = 'ux-comunas';
    COMUNAS.forEach(function (c) {
      var o = document.createElement('option');
      o.value = c;               // texto controlado (constante), asignado como valor -> sin XSS
      dl.appendChild(o);
    });
    document.body.appendChild(dl);
  }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- RUT chileno, modulo 11 ---------- */
  function dv(body) {
    var suma = 0, mul = 2;
    for (var i = body.length - 1; i >= 0; i--) {
      suma += parseInt(body[i], 10) * mul;
      mul = mul === 7 ? 2 : mul + 1;
    }
    var r = 11 - (suma % 11);
    if (r === 11) return '0';
    if (r === 10) return 'K';
    return String(r);
  }
  function rutOk(v) {
    var limpio = (v || '').replace(/[.\-\s]/g, '').toUpperCase();
    var body = limpio.slice(0, -1), d = limpio.slice(-1);
    return /^\d+$/.test(body) && body.length >= 7 && dv(body) === d;
  }

  /* ---------- persistencia como cart attributes ---------- */
  var pendientes = {}, timer = null;
  function pushAttrs(attrs) {
    Object.keys(attrs).forEach(function (k) { pendientes[k] = attrs[k]; });
    clearTimeout(timer);
    timer = setTimeout(function () {
      var envio = pendientes; pendientes = {};
      if (!Object.keys(envio).length) return;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: envio })
      }).catch(function () { /* silencioso: el submit del form tambien manda los inputs */ });
    }, 350);
  }

  /* ---------- estado / validacion ---------- */
  function raizActiva() {
    var vis = all('.ux-doc').filter(function (el) { return el.offsetParent !== null; });
    return vis[0] || $('.ux-doc');
  }
  function valorDe(root, campo) {
    var el = $('[data-ux="' + campo + '"]', root);
    return el ? el.value.trim() : '';
  }
  function esFactura(root) {
    var t = $('[data-ux="documento"]', root);
    return !!t && t.value === 'factura';
  }
  function faltantes(root) {
    return REQUERIDOS.filter(function (c) { return !valorDe(root, c); });
  }
  function pintarRut(root) {
    var input = $('[data-ux="rut"]', root), msg = $('[data-ux="rut-msg"]', root);
    if (!input || !msg) return true;
    if (!esFactura(root)) { msg.textContent = ''; input.classList.remove('ux-doc__in--err'); return true; }
    if (!input.value.trim()) { msg.textContent = ''; input.classList.remove('ux-doc__in--err'); return false; }
    var ok = rutOk(input.value);
    msg.textContent = ok ? 'RUT valido' : 'RUT invalido: revisa el digito verificador';
    msg.className = 'ux-doc__msg ' + (ok ? 'ux-doc__msg--ok' : 'ux-doc__msg--err');
    input.classList.toggle('ux-doc__in--err', !ok);
    return ok;
  }
  function setDoc(root, doc) {
    var hidden = $('[data-ux="documento"]', root);
    var campos = $('[data-ux="campos"]', root);
    if (hidden) hidden.value = doc;
    all('.ux-doc__opt', root).forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-doc') === doc ? 'true' : 'false');
    });
    if (campos) campos.style.display = doc === 'factura' ? 'block' : 'none';
    pushAttrs({ billing_documento: doc });
    if (doc === 'factura') pintarRut(root);
  }

  /* ---------- init idempotente ---------- */
  function init() {
    ensureDatalist();
    all('.ux-doc').forEach(function (root) {
      if (root.getAttribute('data-ux-init')) return;
      root.setAttribute('data-ux-init', '1');
      var comuna = $('[data-ux="comuna"]', root);
      if (comuna && !comuna.getAttribute('list')) comuna.setAttribute('list', 'ux-comunas');
      var hidden = $('[data-ux="documento"]', root);
      setDoc(root, hidden && hidden.value === 'factura' ? 'factura' : 'boleta');
    });
  }

  /* ---------- delegacion: clicks en el toggle ---------- */
  document.addEventListener('click', function (e) {
    var opt = e.target.closest && e.target.closest('.ux-doc__opt');
    if (!opt) return;
    e.preventDefault();
    var root = opt.closest('.ux-doc');
    if (root) setDoc(root, opt.getAttribute('data-doc'));
  });

  /* ---------- delegacion: escritura en los campos ---------- */
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el.getAttribute || !el.getAttribute('data-ux-attr')) return;
    var root = el.closest('.ux-doc');
    if (root && el.getAttribute('data-ux') === 'rut') pintarRut(root);
    var a = {}; a[el.getAttribute('data-ux-attr')] = el.value;
    pushAttrs(a);
  });

  /* ---------- bloqueo del checkout si falta algo ---------- */
  function bloquear(e) {
    var root = raizActiva();
    if (!root || !esFactura(root)) return;
    var falta = faltantes(root);
    var rutValido = rutOk(valorDe(root, 'rut'));
    if (!falta.length && rutValido) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    var msg = $('[data-ux="rut-msg"]', root);
    if (msg) {
      msg.textContent = falta.length
        ? 'Completa todos los datos de facturacion'
        : 'RUT invalido: revisa el digito verificador';
      msg.className = 'ux-doc__msg ux-doc__msg--err';
    }
    pintarRut(root);
    root.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    var act = f.getAttribute('action') || '';
    if (!/\/cart/.test(act) && f.id !== 'cart' && !f.classList.contains('js-cart-form')) return;
    bloquear(e);
  }, true);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[name="checkout"]');
    if (btn) bloquear(e);
  }, true);

  /* ---------- re-init tras render AJAX del carrito ---------- */
  function observar() {
    if (!window.MutationObserver || !document.body) return;
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(init, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); observar(); });
  } else { init(); observar(); }
})();
